// extracted by mini-css-extract-plugin
export default {"replies":"tweet-replies_replies__XO3J7","link":"tweet-replies_link__CMwP6","text":"tweet-replies_text__f5INu"};